import React from "react";
import { Box, Paper, Typography, Button, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuthProvider } from "../../providers";

export const PaymentSuccessScreen = () => {
    const theme = useTheme();
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { authInfo: { user: { role_value } } } = useAuthProvider()

    const orderId = params.get("orderId");
    const isDark = theme.palette.mode === "dark";

    console.log("role_value ==>", role_value)
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: isDark ? "#121212" : "#ffffff",
                p: 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    width: "100%",
                    maxWidth: 450,
                    p: 4,
                    borderRadius: 4,
                    textAlign: "center",

                    // 🔥 FIX: Better contrast in light mode
                    backgroundColor: isDark ? theme.palette.background.paper : "#f5f5f5",
                }}
            >
                <CheckCircleIcon
                    sx={{
                        fontSize: 90,
                        color: "success.main",
                        mb: 2,
                        animation: "pop 0.4s ease-out",
                    }}
                />

                <Typography variant="h4" fontWeight={600} gutterBottom>
                    Payment Successful!
                </Typography>

                <Typography variant="body1" color="text.secondary" mb={3}>
                    Thank you for your order.
                    {orderId && (
                        <>
                            <br /> Your Order ID: <strong>{orderId}</strong>
                        </>
                    )}
                </Typography>

                <Button
                    fullWidth
                    sx={{
                        mb: 2,
                        py: 1.2,
                        fontWeight: 600,
                        borderRadius: 2,

                        // 🔥 Custom button colors
                        backgroundColor: isDark ? "#4caf50" : "#2e7d32",
                        color: "#fff",
                        "&:hover": {
                            backgroundColor: isDark ? "#45a049" : "#256928",
                        },
                    }}
                    onClick={() => navigate(role_value?.toUpperCase() === "USER" ? "/order-history" : "/orders" )}
                >
                    View Orders
                </Button>
                <Button
                    fullWidth
                    sx={{
                        mb: 2,
                        py: 1.2,
                        fontWeight: 600,
                        borderRadius: 2,

                        // 🔥 Custom button colors
                        backgroundColor: isDark ? "#4caf50" : "#2e7d32",
                        color: "#fff",
                        "&:hover": {
                            backgroundColor: isDark ? "#45a049" : "#256928",
                        },
                    }}
                    onClick={() => navigate(`/order-menu?type=TAKE_AWAY`)}
                >
                    New Order
                </Button>
            </Paper>

            {/* Animation */}
            <style>{`
                @keyframes pop {
                    0% { transform: scale(0.5); opacity: 0.2; }
                    100% { transform: scale(1); opacity: 1; }
                }
            `}</style>
        </Box>
    );
};
